export const FINAL_RESULT_REVEAL_DELAYS_MS = [1980, 3060, 4380] as const;
export const FINAL_RESULTS_FULL_LIST_AFTER_FIRST_REVEAL_MS = 10000;

export const getFinalResultRevealDelayMs = (revealIndex: number): number =>
    FINAL_RESULT_REVEAL_DELAYS_MS[
        Math.min(Math.max(Math.round(revealIndex), 0), FINAL_RESULT_REVEAL_DELAYS_MS.length - 1)
    ];

export const getFinalResultsFullListDelayMs = (groupCount: number): number =>
    groupCount > 0
        ? getFinalResultRevealDelayMs(groupCount - 1) + FINAL_RESULTS_FULL_LIST_AFTER_FIRST_REVEAL_MS
        : 0;
